export const sgPageTemplateImageTypeValues = ['SQUARE', 'WIDE'];